export default "__VITE_ASSET__BKvrO_0G__"